/*
 * Copyright (c) 2012 Mathieu Turcotte
 * Licensed under the MIT license.
 */
module.exports = require('./lib/checks');